import { Formik } from "formik";
import { FC, createContext } from "react";
import TableDSVatTu from "./component/TableDSVatTu";

export interface DanhMucContextProps { };

interface TheKhoProps {}

const initialContext = {};

export const DanhMucContext = createContext<DanhMucContextProps>(initialContext)

export const DanhMuc: FC<TheKhoProps> = (props) => {
    return (
        <Formik<any>
            initialValues={{}}
            onSubmit={() => { }}
        >
            <DanhMucContext.Provider value={{}}>
                <div className="bg-white">
                    <div className="flex-1 flex flex-column">
                        <div className="py-1 ">
                            <TableDSVatTu />
                        </div>
                    </div>
                </div>
            </DanhMucContext.Provider>
        </Formik>
    )
}

export default DanhMuc;
